import React from 'react';
import ImgLoader from '../Generic/ImgLoader';
import { Image } from '~/types';
import { SxProp } from 'theme-ui';
type Props = {
  desktopImage: Image;
  mobileImage?: Image;
  forwardSx?: SxProp['sx'];
};
const DesktopOrMobileImage = ({ desktopImage, mobileImage, forwardSx }: Props) => {
  if (!mobileImage) {
    return <ImgLoader forwardSx={{ height: '100%', ...forwardSx }} image={desktopImage} />;
  }

  return (
    <>
      <ImgLoader forwardSx={{ display: ['none', 'block'], height: '100%', ...forwardSx }} image={desktopImage} />
      <ImgLoader forwardSx={{ display: ['block', 'none'], height: '100%', ...forwardSx }} image={mobileImage} />
    </>
  );
};

export default DesktopOrMobileImage;
